import React, { useCallback, useMemo } from 'react'

export type TLogContext = {
  logs: unknown[]
  addLog: (log: unknown) => void
}

export const LogContext = React.createContext<TLogContext>({
  logs: [],
  addLog() {
    throw Error('Missing LogProvider')
  },
})

export const useLogContext = (): TLogContext => {
  return React.useContext(LogContext)
}

/**
 * Used to display logs in the UI when developer tools are unavailable, e.g. native mobile where remote debugging
 * alters the expected behavior.
 */
export const LogProvider: React.FC = ({ children }) => {
  const [logs, setLogs] = React.useState<unknown[]>([])

  const addLog = useCallback(
    (log: unknown): void => {
      console.log(log)
      setLogs((prevLogs) => [...prevLogs, log])
    },
    [setLogs]
  )

  const value: TLogContext = useMemo(
    () => ({
      logs,
      addLog,
    }),
    [logs, addLog]
  )

  return <LogContext.Provider value={value}>{children}</LogContext.Provider>
}
